export default __webpack_public_path__ + "static/caption-03-chs-39db6cc118e05397264014dfcfc3b6b9.webp";